import React, { useEffect, useRef } from 'react';
import './BubbleBackground.css';

const BubbleBackground = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create bubbles dynamically
    const createBubble = () => {
      const bubble = document.createElement('div');
      bubble.className = 'bubble';
      
      // Random size between 40px and 120px
      const size = Math.random() * 80 + 40;
      bubble.style.width = size + 'px';
      bubble.style.height = size + 'px';
      
      // Random horizontal position
      bubble.style.left = Math.random() * 100 + '%';
      
      // Random animation duration between 15s and 35s
      const duration = Math.random() * 20 + 15;
      bubble.style.animationDuration = duration + 's';
      
      // Random delay
      const delay = Math.random() * 5;
      bubble.style.animationDelay = delay + 's';
      
      container.appendChild(bubble);
      
      // Remove bubble after animation completes
      setTimeout(() => {
        if (bubble.parentNode) {
          bubble.parentNode.removeChild(bubble);
        }
      }, (duration + delay) * 1000);
    };

    // Create initial bubbles
    for (let i = 0; i < 6; i++) {
      setTimeout(createBubble, i * 2000);
    }

    // Create new bubbles periodically
    const interval = setInterval(createBubble, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="bubble-background" ref={containerRef}>
      {/* Static parallax elements */}
      <div className="parallax-element" style={{
        width: '200px',
        height: '200px',
        top: '10%',
        left: '5%',
        animationDelay: '0s'
      }}></div>
      <div className="parallax-element" style={{
        width: '150px',
        height: '150px',
        top: '60%',
        right: '10%',
        animationDelay: '3s'
      }}></div>
      <div className="parallax-element" style={{
        width: '100px',
        height: '100px',
        top: '30%',
        right: '20%',
        animationDelay: '6s'
      }}></div>
      <div className="parallax-element" style={{
        width: '180px',
        height: '180px',
        bottom: '20%',
        left: '15%',
        animationDelay: '9s'
      }}></div>
    </div>
  );
};

export default BubbleBackground;
